import { EUserActionTypes } from '../../actions/user';
import { TUser } from '../../types/currentUser';
import { TReduxActions } from '../../types/redux';

const defaultState: TUser = null;

export function userReducer(state: TUser = defaultState, action: TReduxActions) {
  switch (action.type) {
    case EUserActionTypes.SetUser: {
      return action.payload;
    }

    default:
      return state;
  }
}
